module.exports = __webpack_public_path__ + "eb16360a5b28704b02f635b6ceddc1ea.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/banjo-s.png
// module id = 1231
// module chunks = 0